import {EventType} from '@azure/msal-browser';
import {useMsal} from '@azure/msal-react';
import {useEffect} from 'react';

import type {AuthenticationResult, SilentRequest} from '@azure/msal-browser';

export function useTokenSync(
  request: {scopes: string[]},
  onToken: (token: string) => void
): void {
  const {instance} = useMsal();

  useEffect(() => {
    const account = instance.getActiveAccount();
    if (!account) return;

    void instance
      .acquireTokenSilent({...(request as SilentRequest), account})
      .then((result) => onToken(result.accessToken))
      .catch(() => {});

    const id = instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.LOGIN_SUCCESS
      ) {
        onToken((event.payload as AuthenticationResult).accessToken);
      }
    });

    return () => { if (id) instance.removeEventCallback(id); };
  }, [instance, request, onToken]);
}
